module.exports = __webpack_public_path__ + "static/media/map.494828a8.svg";